import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Transition } from '@headlessui/react';
import { Button, Icon } from '@unite-us/app-components';

const RejectTaskModal = ({
  show,
  onClose,
  onConfirm,
  loading,
}) => (
  <Transition.Root show={show} as={Fragment}>
    <Dialog
      as="div"
      className="relative"
      style={{ zIndex: 110 }}
      onClose={onClose}
    >
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-0"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-0"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </Transition.Child>

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-0"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-0"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel
              className={
                'relative transform rounded-lg bg-white text-left shadow-xl ' +
                'transition-all sm:mb-8 sm:mt-20 sm:w-full sm:max-w-md'
              }
              data-testid="reject-task-modal"
            >
              <Dialog.Title
                as="div"
                className="bg-white px-6 py-4 flex justify-between items-center rounded-t-lg"
              >
                <h3 className="text-lg font-extrabold leading-6 text-dark-blue">
                  Reject this task?
                </h3>
                <Icon
                  icon="Cross"
                  size={12}
                  color="dark-blue"
                  onClick={onClose}
                  className="stroke-current stroke-1 cursor-pointer"
                />
              </Dialog.Title>

              <Dialog.Description
                as="div"
                className="px-6 py-5 bg-light-border-grey border-t border-b border-solid border-med-pale-blue"
              >
                <p className="text-sm text-gray-700">
                  This will reject the client relationship and associated task for your
                  organization. The task will be sent back to the Lead Provider.
                </p>
              </Dialog.Description>

              <div className="gap-2 bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 rounded-b-lg">
                <Button
                  label={loading ? 'Rejecting...' : 'Confirm Rejection'}
                  data-testid="confirm-reject-task"
                  primary
                  disabled={loading}
                  onClick={onConfirm}
                  className="font-regular-font"
                />
                <Button
                  label="Cancel and Return"
                  data-testid="cancel-reject-task"
                  secondary
                  disabled={loading}
                  onClick={onClose}
                  className="font-regular-font"
                />
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition.Root>
);

RejectTaskModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default RejectTaskModal;
